import { useSelector } from "react-redux";
import { Reservations } from "redux/reducers/reservationsSlice";
import { RootSliceType } from "redux/reducers/rootReducer";
import {IReservationGroup} from "../reducers/studentReservationGroupLessons";

export const useReservationsGroup = () => {
    const reservationGroup = useSelector<
        RootSliceType,
        IReservationGroup["reservationGroup"]
        >((state) => state.reservationGroupSlice.reservationGroup);
    const loading =  useSelector<
        RootSliceType,
        IReservationGroup['loading']
        >((state) => state.reservationGroupSlice.loading);

    return {
        reservationGroup,
        loading,
    };
};

export default useReservationsGroup;
